(function () {
  function readConfig() {
    var el = document.getElementById('mxpr-favorites-config');
    if (!el) return { isCustomer: false, allowGuest: false, loginUrl: '/account/login' };
    try {
      return JSON.parse(el.textContent) || {};
    } catch (error) {
      return { isCustomer: false, allowGuest: false, loginUrl: '/account/login' };
    }
  }

  var config = readConfig();

  if (!window.mxProductInfoCollection) {
    window.mxProductInfoCollection = {};
  }

  function collectProductInfo() {
    document.querySelectorAll('[data-mxpr-product]').forEach(function (el) {
      var raw = el.getAttribute('data-mxpr-product');
      if (!raw) return;
      try {
        var info = JSON.parse(raw);
        if (info && info.handle) {
          window.mxProductInfoCollection[info.handle] = info;
        }
      } catch (error) {}
    });
  }

  window.handleClick = function (productHash) {
    var variants = document.querySelector('.prime-review-favorites-product-' + productHash + '-variants');
    var card = document.querySelector('[data-mxpr-favorite][data-product-hash="' + productHash + '"]');
    if (variants) {
      if (variants.dataset.hasOnlyDefaultVariant == 'true') {
        window.toggleFavorite(variants.firstElementChild);
      } else if (variants.style.display == 'block') {
        variants.style.display = 'none';
      } else {
        variants.style.display = 'block';
      }
      return;
    }
    if (card && card.dataset.hasOnlyDefaultVariant == 'true') {
      window.toggleFavorite(card);
    }
  };

  window.refreshHeart = function (productHash) {
    var list = document.querySelectorAll('.prime-review-favorites-product-' + productHash + '-variants *');
    var exist = false;
    var heart = document.querySelector('.prime-review-favorites-heart-' + productHash);
    var border = document.querySelector('.prime-review-favorites-heart-border-' + productHash);
    var card = document.querySelector('[data-mxpr-favorite][data-product-hash="' + productHash + '"]');
    for (var i = 0; i < list.length; i++) {
      if (list[i].classList.contains('exist')) {
        exist = true;
      }
    }
    if (card && card.classList.contains('exist')) {
      exist = true;
    }
    if (!heart) return;
    if (exist) {
      heart.classList.remove('prime-review-favorites-heart-' + productHash + '-disable');
      heart.classList.add('prime-review-favorites-heart-' + productHash + '-enable');
      heart.classList.add('is-favorite');
      if (border) {
        border.classList.remove('prime-review-favorites-heart-border-' + productHash + '-disable');
        border.classList.add('prime-review-favorites-heart-border-' + productHash + '-enable');
      }
    } else {
      heart.classList.remove('prime-review-favorites-heart-' + productHash + '-enable');
      heart.classList.add('prime-review-favorites-heart-' + productHash + '-disable');
      heart.classList.remove('is-favorite');
      if (border) {
        border.classList.remove('prime-review-favorites-heart-border-' + productHash + '-enable');
        border.classList.add('prime-review-favorites-heart-border-' + productHash + '-disable');
      }
    }
  };

  window.getVariantInfo = function (handle, variantId) {
    var product = window.mxProductInfoCollection[handle];
    if (!product || !product.variants || !product.variants.length) {
      return {
        imageUrl: null,
        url: '/products/' + handle,
        title: '',
        handle: handle,
        variantTitle: '',
        variantId: variantId,
        price: 0,
        tags: []
      };
    }

    var variant;
    if (variantId) {
      variant = product.variants.find(function (item) {
        return item.id == variantId;
      });
    }
    if (!variant) {
      variant = product.variants[0];
    }

    var variantInfo = {
      imageUrl: product.featured_image || null,
      url: '/products/' + product.handle,
      title: product.title,
      handle: product.handle,
      variantTitle: variant.public_title || variant.title,
      variantId: variant.id,
      price: variant.price,
      tags: product.tags || []
    };

    if (variant) {
      variantInfo.variantId = variant.id;
      variantInfo.price = variant.price;
    } else {
      var prices = product.variants.map(function (item) {
        return item.price;
      });
      variantInfo.minPrice = Math.min.apply(Math, prices);
      variantInfo.maxPrice = Math.max.apply(Math, prices);
    }

    return variantInfo;
  };

  window.changeFloatCount = function (add, variantId) {
    var floatCountDiv = document.getElementById('prime-review-favorites-count');
    if (floatCountDiv) {
      var count = Number(floatCountDiv.innerText) || 0;
      count = count + add;
      floatCountDiv.innerText = String(count);
      if (count <= 0) {
        floatCountDiv.style.display = 'none';
      } else {
        floatCountDiv.style.background = '';
        floatCountDiv.style.display = 'flex';
      }
    }
    var variants = document.querySelectorAll('li.prime-review-variant-' + variantId + ', [data-mxpr-favorite][data-variant-id="' + variantId + '"]');
    for (var i = 0; i < variants.length; i++) {
      if (add == 1) {
        variants[i].classList.add('exist');
      } else {
        variants[i].classList.remove('exist');
      }
      window.refreshHeart(variants[i].dataset.productHash);
    }
  };

  window.submitFavorite = async function (url, handle, variant) {
    await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        handle: handle,
        variant: variant
      })
    });
  };

  window.toggleFavorite = function (source) {
    if (!source) return;
    var variantId = source.dataset.variantId;
    var handle = source.dataset.handle;
    var productHash = source.dataset.productHash;

    if (config.isCustomer) {
      if (source.classList.contains('exist')) {
        window.submitFavorite('/tools/prime-review/api/removeFavorite', handle, variantId);
        window.changeFloatCount(-1, variantId);
      } else {
        window.submitFavorite('/tools/prime-review/api/addFavorite', handle, variantId);
        window.changeFloatCount(1, variantId);
      }
    } else if (config.allowGuest) {
      var favorites = JSON.parse(localStorage.getItem('mxpr-favorites')) || [];
      if (favorites.some(function (favorite) {
        return favorite.variantId == variantId;
      })) {
        var index = favorites.findIndex(function (favorite) {
          return favorite.variantId == variantId;
        });
        if (index >= 0) {
          favorites.splice(index, 1);
          localStorage.setItem('mxpr-favorites', JSON.stringify(favorites));
        }
        window.changeFloatCount(-1, variantId);
      } else {
        favorites.unshift(window.getVariantInfo(handle, variantId));
        localStorage.setItem('mxpr-favorites', JSON.stringify(favorites));
        window.changeFloatCount(1, variantId);
      }
    } else if (confirm('この機能を利用するにはログインが必要です。')) {
      location.href = config.loginUrl || '/account/login';
    }

    if (navigator.maxTouchPoints > 0 && productHash) {
      var variants = document.querySelector('.prime-review-favorites-product-' + productHash + '-variants');
      if (variants) variants.style.display = 'none';
    }
  };

  window.checkCookies = function (productHash, handle) {
    var favorites = JSON.parse(localStorage.getItem('mxpr-favorites')) || [];
    if (favorites.some(function (favorite) {
      return favorite.handle == handle;
    })) {
      var heart = document.querySelector('.prime-review-favorites-heart-' + productHash);
      if (heart) {
        heart.classList.remove('prime-review-favorites-heart-' + productHash + '-disable');
        heart.classList.add('prime-review-favorites-heart-' + productHash + '-enable');
        heart.classList.add('is-favorite');
      }
      var border = document.querySelector('.prime-review-favorites-heart-border-' + productHash);
      if (border) {
        border.classList.remove('prime-review-favorites-heart-border-' + productHash + '-disable');
        border.classList.add('prime-review-favorites-heart-border-' + productHash + '-enable');
      }
    }
    var list = document.querySelectorAll('.prime-review-favorites-product-' + productHash + '-variants *');
    for (var i = 0; i < list.length; i++) {
      if (favorites.some(function (favorite) {
        return list[i].dataset.variantId == String(favorite.variantId);
      })) {
        list[i].classList.add('exist');
      }
    }
    var card = document.querySelector('[data-mxpr-favorite][data-product-hash="' + productHash + '"]');
    if (card && card.dataset.variantId && favorites.some(function (favorite) {
      return String(favorite.variantId) == String(card.dataset.variantId);
    })) {
      card.classList.add('exist');
    }
  };

  function bindCard(card) {
    if (!card || card.dataset.mxprBound === 'true') return;
    card.dataset.mxprBound = 'true';
    var productHash = card.getAttribute('data-product-hash');
    var handle = card.getAttribute('data-handle');
    var variants = document.querySelector('.prime-review-favorites-product-' + productHash + '-variants');

    card.addEventListener('click', function () {
      window.handleClick(productHash);
    }, true);

    if (variants) {
      variants.addEventListener('mouseleave', function (event) {
        event.target.style.display = 'none';
      });
      variants.addEventListener('click', function (event) {
        var item = event.target.closest('li');
        if (item) window.toggleFavorite(item);
      });
    }

    if (!config.isCustomer && config.allowGuest && productHash && handle) {
      window.checkCookies(productHash, handle);
    }
  }

  function initCards() {
    collectProductInfo();
    document.querySelectorAll('[data-mxpr-favorite]').forEach(bindCard);
  }

  window.mxprInitCards = initCards;

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    initCards();
    window.addEventListener('load', initCards);
  });

  document.addEventListener('shopify:section:load', initCards);
})();
